import React, { useCallback, useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";

import {
  Box,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Tooltip,
  Menu,
} from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploads from "../Alert/FileUploads";
import AddNotes from "../Alert/AddNotes";
import RenamePopup from "../Alert/Rename";
import RejectFile from "../Alert/RejectFile";
import MoveToPreflightPopup from "../Alert/MoveToPreflightPopup";
import MoveToFinal from "../Alert/MoveToFinal";
import ReprocessSendToPreflight from "../Alert/ReprocessSendToPreflight";

import { RequestModel, DialogProps } from "../../types/SimpleSearchModel";
import {
  downloadFile,
  getSimpleSearchData,
  multipleDownloadFile,
} from "../../api/simpleSearchApi/simpleSearchApi";
import ConfirmationDialog from "./ConfirmationDialog";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import InfoDrawer from "./InfoDrawer";
import "../../config/colors.css";
import { UserModel } from "../../types/userDataModel"; // NOSONAR
import { DownstreamreprocessModel } from "../../types/DownstreamreprocessModel";
import { GetARFDocuments } from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import { ARFDocument } from "../../types/ARFDocumentModel";
import { useLoader } from "../../context/LoaderContext";
import { useSnackbar } from "../Common/SnackbarContext";
import { getFileDownload } from "../../api/advanceSearchApi/advanceSearchApi";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import { urlConfig } from "../../config/urlConfig";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ConfirmationAlert from "../Alert/ConfirmationAlert";
import AssetHistory from "../Alert/AssetHistory";
import HistoryIcon from "@mui/icons-material/History";
import DownstreamSubSystemReprocessPopup from "../Alert/DownstreamSubSystemReprocessPopup";
import { FormatDate } from "../Common/CommonMethods";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
const SimpleSearch = () => {
  const { showSnackbar } = useSnackbar();
  const { setLoading } = useLoader();
  const [txtSearch, setTxtSearch] = useState("");
  const [resetShow, setResetShow] = useState(false);
  const [resetErrorMsg, setResetErrorMsg] = useState(false);
  const [ShowRecords, setShowRecords] = useState(false);
  const [zipDownload, setZipDownload] = useState(false);
  const [deleteRightShow, setDeleteRightShow] = useState(false);
  const [gridApi, setGridApi] = useState<any>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [onSearchClick, setOnSearchClick] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [loggedUserData, setLoggedUserData] = useState<UserModel | null>(null);
  const [, setIsAccountDAOEnabled] = useState<boolean>(true); // NOSONAR
  const [, setIsAccountDSAEnabled] = useState<boolean>(false); // NOSONAR
  const [, setIsAccountEdeliveryEnabled] = useState<boolean>(true); // NOSONAR

  //#region Context Menu
  const [deleteConfirmationDialogOpen, setdeleteConfirmationDialogOpen] =
    useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = useState<any>(null);
  const [isArfMessage, setIsArfMessage] = useState(false);
  const [reprocessSubSystemOpen, setReprocessSubSystemOpen] = useState(false);
  const [reprocessSubSystemOpenData, setReprocessSubSystemOpenData] =
    useState<any>(null);
  const [, setReprocessFDOpen] = useState(false); // NOSONAR
  const [, setReprocessFDOpenData] = useState<any>(null); // NOSONAR
  const [, setReprocessEDeliveryOpen] = useState(false); // NOSONAR
  const [, setReprocessEDeliveryOpenData] = useState<any>(null); // NOSONAR
  const [rowData, setRowData] = useState<any[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const [, setGridRecordExist] = useState(false); // NOSONAR
  const [assetHistoryOpen, setAssetHistoryOpen] = useState(false);
  const [assetHistoryData, setAssetHistoryData] = useState<any>(null);
  const [QueueType, setQueueType] = useState<number>(2);
  const [showLoader, setShowLoader] = useState(false);
  const [uploadFilesOpen, setUploadFilesOpen] = useState(false);
  const [uploadFilesData, setUploadFilesData] = useState<any>(null);
  const [addNotesOpen, setAddNotesOpen] = useState(false);
  const [addNotesData, setAddNotesData] = useState(false);
  const [renamePopupOpen, setRenamePopupOpen] = useState(false);
  const [renameData, setRenameData] = useState<any>(null);
  const [rejectPopupOpen, setRejectPopupOpen] = useState(false);
  const [rejectData, setRejectData] = useState<any>(null);
  const [moveToPreflightOpen, setMoveToPreflightOpen] = useState(false);
  const [moveToPreflightData, setMoveToPreflightData] = useState<any>(null);
  const [moveToFinalFolderOpen, setMoveToFinalFolderOpen] = useState(false);
  const [moveToFinalFolderData, setMoveToFinalFolderData] = useState<any>(null);
  const [moveToFinalPopupTitle, setMoveToFinalPopupTitle] =
    useState<string>("");
  const [reprocessSendToPreflightOpen, setReprocessSendToPreflightOpen] =
    useState(false);
  const [reprocessSendToPreflightData] = useState<any>(null);
  const [documentStatusValue] = useState<number>(0);
  const [contextMenuType, setContextMenuType] = useState<number>(1);

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };
  const [dialogProps, setDialogProps] = useState<DialogProps>({
    dialogTitle: "",
    contentText: "",
    confirmText: "",
    closeText: "",
    onConfirm: null,
  });

  const txtSearchRef = useRef(txtSearch);
  const isSearchClicked = useRef(onSearchClick);
  const gridRef = useRef<AgGridReact>(null);

  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const excludedStatuses = [
    6, 20, 21, 11, 17, 18, 3, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35,
  ];
  const excludedRejectStatuses = [
    6, 20, 23, 24, 11, 27, 17, 18, 28, 30, 31, 32, 33, 34, 35,
  ];

  useEffect(() => {
    txtSearchRef.current = txtSearch;
    isSearchClicked.current = onSearchClick;
    getLoogedUserData();
  }, [txtSearch, onSearchClick]);

  const clearSelectionState = useCallback(() => {
    if (gridRef.current) {
      gridRef.current?.api.setServerSideSelectionState({
        selectAll: false,
        toggledNodes: [],
      });
    }
  }, []);

  const getLoogedUserData = async () => {
    try {
      const userData = LocalStorageUtil.getItem("authorizationData");
      if (userData) {
        setLoggedUserData(JSON.parse(userData));
        setIsAccountDAOEnabled(loggedUserData?.isAccountDAOEnabled === "True");
        setIsAccountDSAEnabled(loggedUserData?.isAccountDSAEnabled === "True");
        setIsAccountEdeliveryEnabled(
          loggedUserData?.isAccountEdeliveryEnabled === "True"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  //History - Action buttons events
  const viewHistory = (rowData: any) => {
    setAssetHistoryData(rowData);
    setAssetHistoryOpen(true);
  };

  // Close AssetHistory
  const closeAssetHistory = () => {
    setAssetHistoryOpen(false);
    setAssetHistoryData(null);
  };

  // Helper function to map action types to handlers

  const getActionHandler = (
    actionType: number
  ): ((rowData: any) => void) | null => {
    const actionMap: Record<number, (rowData: any) => void> = {
      0: handelDeleteContextMenuOption,
      1: handleReprocessTosource,
      2: handleSendToPreflight_SendToDownSample,
      3: handleSendToPreflight_SendToDownSample,
      4: handleSendToEDelivery,
      5: (rowData) => handelUploadFiles(rowData, 1),
      6: handleAddNotes,
      7: (rowData) => moveToPreflight(rowData, 0),
      9: (rowData) => moveToFinalFolder(rowData, 0, 2),
      10: (rowData) => moveToFinalFolder(rowData, 0, 3),
      11: (rowData) => moveToFinalFolder(rowData, 0, 1),
      12: (rowData) => moveToFinalFolder(rowData, 0, 1),
      14: handleRename,
      15: handleReject,
    };

    return actionMap[actionType] || null;
  };

  // Helper function to render action buttons
  const renderActionButtons = (
    rowData: any,
    fileDownload: (data: any) => void,
    viewDocument: (data: any) => void,
    infoDocument: (data: any) => void,
    viewHistory: (data: any) => void
  ) => {
    return (
      <>
        {isPagePermission("Allow Download", "Search", 805) && (
          <Tooltip title="Click here to download the document(s)">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => fileDownload(rowData)}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
        )}

        {isPagePermission("Allow DocumentPreView", "Search", 806) && (
          <Tooltip title="Click to view file">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewDocument(rowData)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        )}

        {isPagePermission("Allow Metadata Information", "Search", 802) && (
          <Tooltip title="Click to view file information and history">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => infoDocument(rowData)}
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
        )}

        {isPagePermission("Allow Asset History", "Downstream") && (
          <Tooltip title="Click to view the asset history">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewHistory(rowData)}
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  };

  // Helper function to render context menu items for QueueType 2
  const renderQueueType2MenuItems = (
    params: any,
    rowData: any,
    handleClose: (actionType: number, rowData: any) => void
  ) => {
    return [
      params.data.IsAllowSubSystemReprocess === "True" &&
        params.data["ACTION CODE"] !== "ARF" &&
        isPagePermission("", "", 1446) &&
        LocalStorageUtil.getItem("contextName") !== "DocDistro_MOAForms" && (
          <MenuItem
            key={`reprocess-to-source-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(1, rowData)}
          >
            Reprocess to Source
          </MenuItem>
        ),
      rowData.Rendition_Intern?.toUpperCase() ===
        "CURRENT (PRINT-READY VERSION)" &&
        isPagePermission("Allow Send to Preflight", "Search", 1363) && (
          <MenuItem
            key={`send-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(2, rowData)}
          >
            Send to Preflight
          </MenuItem>
        ),
      isPagePermission("Allow Send to Downsample", "Search", 1364) &&
        ((rowData.DocumentStatus === "2" &&
          rowData.Rendition_Intern?.toUpperCase() ===
            "CURRENT (PRINT-READY VERSION)") ||
          rowData.Rendition_Intern.toUpperCase() === "CURRENT") && (
          <MenuItem
            key={`send-to-downsample-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(3, rowData)}
          >
            Send to Downsample
          </MenuItem>
        ),
      isPagePermission("Allow Send to Edelivery", "Search", 1365) &&
        rowData.Rendition_Intern?.toUpperCase() === "CURRENT" && (
          <MenuItem
            key={`send-to-edelivery-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(4, rowData)}
          >
            Send to E-delivery
          </MenuItem>
        ),
    ];
  };

  // Helper function to render context menu items for QueueType 1
  const renderQueueType1MenuItems = (
    rowData: any,
    handleClose: (actionType: number, rowData: any) => void,
    excludedStatuses: number[],
    excludedRejectStatuses: number[],
    checkPermission: (permission: string) => boolean
  ) => {
    return [
      isPagePermission("Allow Download", "Search", 805) &&
        !excludedStatuses.includes(Number(rowData.DocumentStatus)) && (
          <MenuItem
            key={`upload-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(5, rowData)}
          >
            Upload
          </MenuItem>
        ),
      checkPermission("Allow Add Notes") && rowData.DocumentStatus !== "20" && (
        <MenuItem
          key={`add-notes-${rowData.DocumentStreamID}`}
          className="context-menu-item"
          onClick={() => handleClose(6, rowData)}
        >
          Add Notes
        </MenuItem>
      ),
      isPagePermission("Allow Move To Preflight", "Search", 1363) &&
        rowData.DocumentStatus === "2" && (
          <MenuItem
            key={`move-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(7, rowData)}
          >
            Move to Preflight
          </MenuItem>
        ),
      isPagePermission("Allow Reprocess - To Preflight", "Search", 1437) &&
        rowData.DocumentStatus === "6" && (
          <MenuItem
            key={`reprocess-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(8, rowData)}
          >
            Reprocess to Preflight
          </MenuItem>
        ),
      isPagePermission("Allow Menu TriggerProofFlow", "Search", 1410) &&
        (rowData.DocumentStatus === "2" ||
          rowData.DocumentStatus === "11" ||
          rowData.DocumentStatus === "18") && (
          <MenuItem
            key={`trigger-proof-wf-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(9, rowData)}
          >
            Trigger Proof WF
          </MenuItem>
        ),
      isPagePermission("Allow Menu TriggerProdFlow", "Search", 1434) &&
        (rowData.DocumentStatus === "11" ||
          rowData.DocumentStatus === "18") && (
          <MenuItem
            key={`trigger-prod-wf-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(10, rowData)}
          >
            Trigger Prod WF
          </MenuItem>
        ),
      isPagePermission("Allow Move To Final Folder", "Search", 1435) &&
        rowData.DocumentStatus === "11" && (
          <MenuItem
            key={`to-final-folder-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(11, rowData)}
          >
            To Final Folder
          </MenuItem>
        ),
      isPagePermission("Allow Move To Final Folder Vis", "Search", 1436) &&
        rowData.DocumentStatus === "18" && (
          <MenuItem
            key={`final-folder-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(12, rowData)}
          >
            To Final Folder
          </MenuItem>
        ),
      isPagePermission("Allow Rename", "Search", 1407) &&
        !excludedStatuses.includes(Number(rowData.DocumentStatus)) && (
          <MenuItem
            key={`rename-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(14, rowData)}
          >
            Rename
          </MenuItem>
        ),
      isPagePermission("Allow Reject", "Search", 1408) &&
        !excludedRejectStatuses.includes(Number(rowData.DocumentStatus)) && (
          <MenuItem
            key={`reject-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(15, rowData)}
          >
            Reject
          </MenuItem>
        ),
    ];
  };

  // Refactored ActionCellRenderer
  const ActionCellRenderer = (params: any) => {
    const { QueueType } = params.context;
    const rowData = params.data;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (actionType: number, rowData: any) => {
      const handler = getActionHandler(actionType);
      if (handler) {
        handler(rowData);
      }
      setAnchorEl(null);
    };

    if (params.data === undefined) {
      return "";
    }

    return (
      <div>
        {renderActionButtons(
          rowData,
          fileDownload,
          viewDocument,
          infoDocument,
          viewHistory
        )}

        <Tooltip title="Please click to view the actions">
          <MoreVertIcon
            className="icon-button"
            onClick={handleClick}
            style={{
              padding: "0.2vh",
              cursor: "pointer",
            }}
          />
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          keepMounted
        >
          {isPagePermission("Allow Delete", "Search", 804) && (
            <MenuItem
              key={`delete-${rowData.DocumentStreamID}`}
              className="context-menu-item"
              onClick={() => handleClose(0, rowData)}
            >
              Delete
            </MenuItem>
          )}

          {QueueType === 2 &&
            renderQueueType2MenuItems(params, rowData, handleClose)}

          {QueueType === 1 &&
            renderQueueType1MenuItems(
              rowData,
              handleClose,
              excludedStatuses,
              excludedRejectStatuses,
              checkPermission
            )}
        </Menu>
      </div>
    );
  };

  const checkPermission = (controlid: string): boolean => {
    if (loggedUserData?.pageControlPermission != null) {
      const permissionData = loggedUserData?.pageControlPermission;
      const permissions = JSON.parse(permissionData);
      const result = permissions.find(
        (permission: { PermissionName: string }) =>
          permission.PermissionName === controlid
      );
      return result;
    }
    return false;
  };

  // Helper function to get selected rows or fallback to provided data
  const getSelectedRowsOrDefault = (gridRef: any, fallbackData: any): any[] => {
    if (!gridRef.current) return [];

    const selectedRows = gridRef.current.api.getSelectedRows();

    if (selectedRows.length === 0 && fallbackData) {
      return Array.isArray(fallbackData) ? fallbackData : [fallbackData];
    }

    return selectedRows;
  };

  // Helper function to get action code from rows
  const getActionCode = (rows: any[]): string => {
    if (rows.length === 0) return "";

    const firstRow = rows[0];
    return Array.isArray(rows) ? firstRow["ACTION CODE"] : rows["ACTION CODE"];
  };

  // Helper function to create ARF document object
  const createArfDocument = (row: any): ARFDocument => {
    return {
      ProjectDocumentIds: row["Document ID"],
      ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
      AccountId: Number(LocalStorageUtil.getItem("accountId")),
      DocumentStreamId: row["DocumentStreamID"],
      UserId: Number(LocalStorageUtil.getItem("userId")),
    };
  };

  // Helper function to build ARF documents array
  const buildArfDocuments = (rows: any[]): ARFDocument[] => {
    if (!Array.isArray(rows)) {
      return [createArfDocument(rows)];
    }

    return rows.map((row) => createArfDocument(row));
  };

  // Helper function to check if ARF documents and show dialog
  const processArfDocuments = async (
    arfDocuments: ARFDocument[],
    actionCode: string,
    setDeleteDocumentData: (data: any) => void,
    setdeleteConfirmationDialogOpen: (open: boolean) => void,
    setIsArfMessage: (isArf: boolean) => void
  ): Promise<void> => {
    if (arfDocuments.length === 0) return;

    const isArfActionCode = actionCode?.toLowerCase() === "arf";

    if (isArfActionCode) {
      // Direct ARF action code - no API call needed
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(false);
      return;
    }

    // Non-ARF action code - check with API
    const arfDocumentResponse = await GetARFDocuments(arfDocuments);
    setDeleteDocumentData(arfDocuments);
    setdeleteConfirmationDialogOpen(true);
    setIsArfMessage(arfDocumentResponse === true);
  };

  // Helper function to validate selection
  const validateSelection = (
    selectedRows: any[],
    showSnackbar: (message: string, isError: boolean) => void
  ): boolean => {
    if (!selectedRows || selectedRows.length === 0) {
      showSnackbar("Please check any one checkbox", true);
      return false;
    }
    return true;
  };

  // Refactored handelDeleteContextMenuOption function
  const handelDeleteContextMenuOption = async (rowsData: any) => {
    try {
      setLoading(true);

      // Get selected rows or use provided data
      const selectedRows = getSelectedRowsOrDefault(gridRef, rowsData);

      // Validate selection
      if (!validateSelection(selectedRows, showSnackbar)) {
        return;
      }

      // Get action code from selected rows
      const actionCode = getActionCode(selectedRows);

      // Build ARF documents array
      const arfDocuments = buildArfDocuments(selectedRows);

      // Process ARF documents and show dialog
      await processArfDocuments(
        arfDocuments,
        actionCode,
        setDeleteDocumentData,
        setdeleteConfirmationDialogOpen,
        setIsArfMessage
      );
    } catch (ex) {
      console.error("Error in handelDeleteContextMenuOption:", {
        error: ex,
        rowsData,
      });
    } finally {
      setLoading(false);
    }
  };

  //Handel reprocess to source
  const handleReprocessTosource = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID:
            rowsData.SubSystemConfigurationId.toString() ?? "",
          ParentDocumentStreamID: rowsData.ParentDocumentStreamID.toString(),
          SubSystemName: rowsData.SubSystemName.toString(),
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID:
              rowsData.SubSystemConfigurationId.toString() ?? "",
            ParentDocumentStreamID: rowsData.ParentDocumentStreamID.toString(),
            SubSystemName: rowsData.SubSystemName.toString(),
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessSubSystemOpenData(downstreamrReprocessModel);
        setReprocessSubSystemOpen(true);
      } else {
        showSnackbar("No document selected to reprocess", true);
      }
    }
  };

  //Handel send to preflight and send to downsample
  const handleSendToPreflight_SendToDownSample = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessFDOpenData(downstreamrReprocessModel);
        setReprocessFDOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //Handel send to e-delivery
  const handleSendToEDelivery = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessEDeliveryOpenData(downstreamrReprocessModel);
        setReprocessEDeliveryOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setResetErrorMsg(false);
    setTxtSearch(e.target.value);
    setResetShow(true);
    setZipDownload(true);
    setDeleteRightShow(true);
  };

  const handleSearchSubmit = useCallback(
    async (e?: React.FormEvent) => {
      if (e) {
        e.preventDefault();
      }
      if (txtSearch === "") {
        setResetErrorMsg(true);
        return;
      }

      const payload: RequestModel = {
        sortOrder: 0,
        sortColumn: null,
        currentPage: 0,
        noOfRecords: 0,
        searchText: txtSearchRef.current,
        accountId: Number(LocalStorageUtil.getItem("accountId")),
        userId: Number(LocalStorageUtil.getItem("userId")),
        isSuperAdmin: 1,
        folderRights: "False",
        contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
        queueType: QueueType,
        isPdfSplitEnabled: "False",
        isAccountDAOEnabled: "False",
        isAccountDSAEnabled: "False",
        isNoSubProcessEnabled: "False",
      };

      fetchData(payload);

      setOnSearchClick(true);
      setShowRecords(true);

      if (gridApi) {
        clearSelectionState();
        gridApi.onFilterChanged();
      }
    },
    [txtSearch, gridApi, clearSelectionState, QueueType]
  );

  //Rename the columns
  const renameColumns = (val: any) => {
    if (val !== undefined) {
      if (val.toLowerCase() === "statement_date") {
        return "Date";
      } else if (val.toLowerCase() === "ngfamily_id") {
        return "Family_Id";
      } else if (val.toLowerCase() === "groupid") {
        return "Group_Id";
      } else if (val.toLowerCase() === "sub_dob") {
        return "DateOfBirth";
      } else if (val.toLowerCase() === "sub_name") {
        return "Name";
      } else if (val.toLowerCase() === "projectdocumentid") {
        return "Document ID";
      } else if (val.toLowerCase() === "dao flag") {
        return "DAO Flag";
      } else if (val.toLowerCase() === "lastmodifieddate") {
        return "Last Modified Date";
      } else if (val.toLowerCase() === "level 1") {
        return "Rendition";
      } else {
        return val.replace(/&amp;/, "&");
      }
    }
  };

  const thumbnailCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      const rowData = params.data;
      if (!rowData.Thumbnail) {
        return <p style={{ marginLeft: "2em" }}>N/A</p>;
      } else {
        return (
          <img
            src={rowData.Thumbnail}
            className="img-responsive"
            alt=""
            width="50px"
            height="50px"
            style={{ margin: "15px" }}
          />
        );
      }
    }
  };

  // Fetch data from API
  const fetchData = async (payload: any) => {
    try {
      setShowLoader(true);
      const response = await getSimpleSearchData(payload);
      let { listSearchModel = [] } = response;
      listSearchModel = listSearchModel.map((item: any) => ({
        ...item,
        Thumbnail: null, // Ensure this field exists for every row
      }));
      if (listSearchModel && listSearchModel.length > 0) {
        const columnsToExclude = [
          "RowNum",
          "FileType",
          "DocumentID",
          "DocumentStreamID",
          "DocumentStatus",
          "QueueType",
          "recordCount",
          "latestDocumentDesc",
          "ProjectDocumentId",
          "FromPreflightJobNumber",
          "ToPreflightJobNumber",
          "RejectRemarks",
          "RenameRemarks",
          "ResolutionStatus",
          "ParentDocumentStreamID",
          "AccessPermission",
          "Thumbnail",
          "fileSize",
          "FinalDocID",
          "ToPreflightZipName",
          "Rendition_Intern",
          "PreworkDynamicFilename",
          "ChildAcceptedId",
          "ChildFileUploadedon",
          "ChildFileAcceptedDate",
          "daoflag_Intern",
          "DownloadFileName",
          "recordCountTemp",
          "SubSystemName",
          "SubSystemConfigurationId",
          "IsAllowSubSystemReprocess",
        ];

        // Dynamically get column headers from the data
        const dynamicColumns = Object.keys(listSearchModel[0])
          .filter((key) => !columnsToExclude.includes(key))
          .map((key) => {
            if (
              (key.toLowerCase().includes("date") &&
                key.toLowerCase() !== "document date" ) ||
              key.toLowerCase() === "uploaded on" ||
              key.toLowerCase() === "aws date"
            ) {
              return {
                headerName: renameColumns(
                  key.charAt(0).toUpperCase() + key.slice(1),
                ),
                field: key,
                sortable: true,
                filter: true,
                enableRowGroup: true,
                valueFormatter: (params: any) => {
                  return FormatDate(params.value);
                },
              };
            } else {
              return {
                headerName: renameColumns(
                  key.charAt(0).toUpperCase() + key.slice(1),
                ),
                field: key,
                sortable: true,
                filter: true,
                enableRowGroup: true,
              };
            }
          });

        // Combine static and dynamic column definitions
        const combinedColumnDefs = [
          {
            width: 10,
            sortable: false,
            filter: false,
            hide: false,
            colId: "colCheckbox",
            //suppressSizeToFit: true,
            enableRowGroup: false,
            resizable: false,
          },
          {
            headerName: "#",
            width: 70,
            colId: "colRowNum",
            sortable: false,
            filter: false,
            resizable: false,
            enableRowGroup: false,
            valueGetter: (params: any) => {
              return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
            },
          },
          {
            headerName: "Thumbnail",
            field: "DocumentID",
            cellRenderer: thumbnailCellRenderer,
            width: 150,
            autoHeight: true,
          },
          ...dynamicColumns,
          {
            field: "Actions",
            headerName: "Actions",
            sortable: false,
            enableRowGroup: false,
            pinned: "right" as const,
            lockPinned: true,
            suppressSizeToFit: true,
            width: 160,
            minWidth: 160,
            cellClass: "actions-button-cell",
            cellRenderer: ActionCellRenderer,
            filter: false,
            resizable: false,
            colId: "colAction",
          },
        ];
        setColumnDefs(combinedColumnDefs);
        let documentId: any[] = [];
        listSearchModel.forEach((item: any) => {
          documentId.push(item.DocumentStreamID);
        });
        try {
          const advanceDocumentViewObj: any = {
            contextName: (
              LocalStorageUtil.getItem("contextName") ?? ""
            ).toString(),
          };
          const thumbnailPayload: any = {
            AdvanceDocumentViewObj: advanceDocumentViewObj,
            fileObj: documentId,
          };
          const thumbnailData = await getFileDownload(thumbnailPayload);

          const { objSearch = [] } = thumbnailData;

          if (objSearch?.searchViewStaticModel != null) {
            listSearchModel.forEach((listItem: any, index: number) => {
              objSearch.searchViewStaticModel.forEach((documentItem: any) => {
                if (
                  Number(listItem.DocumentStreamID) ===
                  documentItem.documentStreamID
                ) {
                  listSearchModel[index].Thumbnail = documentItem.thumbnail
                    ? `data:image/jpeg;base64,${documentItem.thumbnail}`
                    : null;
                }
              });
            });
          }
          showSnackbar(listSearchModel.length + " Records found");
        } catch (error) {}
        setRowData(listSearchModel);
      } else {
        setColumnDefs([]);
        setRowData([]);
        setGridRecordExist(false);
      }
    } catch (error) {
      setColumnDefs([]);
      setRowData([]);
      setGridRecordExist(false);
      setOnSearchClick(false);
    } finally {
      setShowLoader(false);
    }
  };

  const handleReset = () => {
    setTxtSearch("");
    setResetShow(false);
    setShowRecords(false);
    setZipDownload(false);
    setDeleteRightShow(false);
    setQueueType(2);
    if (gridApi) {
      gridApi.destroy();
    }
  };

  const clearSelectedRows = () => {
    gridRef.current!.api.deselectAll();
  };

  const deleteSelectetdDocuments = async () => {
    if (!gridRef.current) return;
    let selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length === 0) {
      showSnackbar("Please select one or more documents to delete.", true);
      return;
    }

    //selectedRows = selectedRows.length > 0 ? selectedRows : rowsData;

    // Helper to build ARFDocument array from rows
    const buildArfDocuments = (rows: any[]): ARFDocument[] =>
      rows.map((row) => ({
        ProjectDocumentIds: row["Document ID"],
        ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        AccountId: Number(LocalStorageUtil.getItem("accountId")),
        DocumentStreamId: row["DocumentStreamID"],
        UserId: Number(LocalStorageUtil.getItem("userId")),
      }));

    // Normalize selectedRows to array
    let rowsArray: any[];
    if (Array.isArray(selectedRows)) {
      rowsArray = selectedRows;
    } else if (selectedRows) {
      rowsArray = [selectedRows];
    } else {
      rowsArray = [];
    }

    if (rowsArray.length === 0) {
      console.log("No document selected to delete");
      return;
    }
    const actionCode =
      (rowsArray[0] as Record<string, any>)["ACTION CODE"]?.toLowerCase?.() ??
      (selectedRows as Record<string, any>)["ACTION CODE"]?.toLowerCase?.();
    // If actionCode is not 'arf', proceed with ARF logic
    if (actionCode !== "arf") {
      const arfDocuments = buildArfDocuments(rowsArray);
      if (arfDocuments.length > 0) {
        const arfDocumentResponse = await GetARFDocuments(arfDocuments);
        setDeleteDocumentData(arfDocuments);
        setdeleteConfirmationDialogOpen(true);
        setIsArfMessage(arfDocumentResponse === true);
      }
      return;
    }
    // If actionCode is 'arf', handle single/multiple selection
    const arfDocuments = buildArfDocuments(rowsArray);
    if (arfDocuments.length > 0) {
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(false);
    }
  };

  const downloadSelectedFiles = () => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      if (selectedRows.length > 1) {
        showSnackbar("Download started ...");
        let documentStreamID: number[] = [];

        selectedRows.forEach((item: any) => {
          documentStreamID.push(item.DocumentStreamID);
        });

        if (documentStreamID.length > 1) {
          let duplicateCheck = false;
          const fileNameMap: Record<string, number> = {};
          selectedRows.forEach((item: any) => {
            const name = item.DownloadFileName?.toLowerCase();
            if (fileNameMap[name]) {
              duplicateCheck = true;
            } else {
              fileNameMap[name] = 1;
            }
          });

          if (duplicateCheck) {
            setDialogProps({
              dialogTitle: "Notification",
              contentText:
                "Please note that your Selection Criteria contains duplicate files.Downloaded Duplicate files will be renamed.",
              confirmText: "OK",
              closeText: "Cancel",
              onConfirm: handleDownloadMultipleFiles,
            });
            setDialogOpen(true);
          } else {
            handleDownloadMultipleFiles();
          }
        }
      } else if (selectedRows.length === 0) {
        showSnackbar("Please select the files to Zip and Download", true);
      } else {
        showSnackbar(
          "Please select more than one file to Zip and Download",
          true
        );
      }
    }
  };

  const handleDownloadMultipleFiles = async () => {
    try {
      if (gridRef.current) {
        const selectedRows = gridRef.current.api.getSelectedRows();
        let multiFileDownload = null;
        if (selectedRows.length > 1) {
          let documentStreamID: number[] = [];

          selectedRows.forEach((item: any) => {
            documentStreamID.push(item.DocumentStreamID);
          });

          if (documentStreamID.length > 1) {
            multiFileDownload = {
              SearchText: documentStreamID.toString(),
              contextName: LocalStorageUtil.getItem("contextName")?.toString(),
            };
          }
        }

        setLoading(true);
        const response = await multipleDownloadFile(multiFileDownload);
        setLoading(false);

        if (response.status === 200) {
          const data = response.data;
          const contentType = response.headers["content-type"];
          const fileName = "documents.zip";

          const linkElement = document.createElement("a");

          const blob = new Blob([data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          linkElement.href = url;
          linkElement.setAttribute("download", fileName);

          const clickEvent = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false,
          });
          linkElement.dispatchEvent(clickEvent);
        }

        if (response) {
          showSnackbar("Documents downloaded successfully");
          clearSelectedRows();
        } else {
          showSnackbar("Unable to download file !", true);
        }
        setDialogOpen(false);
      }
    } catch (error) {
      showSnackbar("Something went wrong ! Please try again.", true);
    } finally {
      setDialogOpen(false);
      setLoading(false);
    }
  };

  const fileDownload = async (params: any) => {
    const objDownloadFile = {
      documentStreamID: params.DocumentStreamID,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };

    try {
      setLoading(true);
      const response = await downloadFile(objDownloadFile);
      setLoading(false);

      if (response.status === 200) {
        const data = response.data;
        const contentType = response.headers["content-type"];

        const linkElement = document.createElement("a");

        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute(
          "download",
          params.ProjectDocumentId + params.FileType
        );

        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }

      if (response) {
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file !", true);
      }

      setDialogOpen(false);
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      setDialogOpen(false);
      setLoading(false);
    }
  };

  const viewDocument = (rowData: any) => {
    const id = rowData.DocumentStreamID;
    const encodedId = btoa(id);
    const fileName = rowData.DownloadFileName.replace(/\.[^/.]+$/, "");
    const url = !urlConfig.isDeployed
      ? `/documentviewer/${encodedId}?FileName=${fileName}`
      : `/docdistrov2/documentviewer/${encodedId}?FileName=${fileName}`;
    popupCenter(url, "Document Viewer", 1100, 550);
  };

  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = width / 3 - w / 3 + dualScreenLeft;
    const top = height / 3 - h / 3 + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `readonly=true, scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  const infoDocument = (rowData: any) => {
    setSelectedDocument(rowData);
    toggleDrawer(true)();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  //Close Confirmation Delete Dialog
  const closeConfirmationDialogbox = (deleted: boolean) => {
    setdeleteConfirmationDialogOpen(false);
    setDeleteDocumentData(null);
    if (deleted) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess SubSystem Dialog
  const closeReprocessSubSystemDialogbox = (isCancelClick: boolean) => {
    setReprocessSubSystemOpen(false);
    setReprocessSubSystemOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  const handleQueueTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQueueType(Number(event.target.value));
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.refreshCells({ force: true }); // Force refresh all cells
    }
  }, [QueueType, gridApi]);

  // Open Upload Files Pop up
  const handelUploadFiles = (rowData: any, value: number) => {
    setUploadFilesOpen(true);
    setUploadFilesData(rowData);
  };

  // Close Upload Files Pop up
  const closeUploadFiles = (isCancelClick: boolean) => {
    setUploadFilesOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Add Notes Pop up
  const handleAddNotes = (rowData: any) => {
    setAddNotesOpen(true);
    setAddNotesData(rowData);
  };

  // Close Add Notes Pop up
  const closeAddNotes = (isCancelClick: boolean, tabValue?: number) => {
    setAddNotesOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Open Rename Pop up
  const handleRename = (rowData: any) => {
    setRenamePopupOpen(true);
    setRenameData(rowData);
  };

  //Close Rename Pop up
  const closeRenamePopup = (isCancelClick: boolean) => {
    setRenamePopupOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Open Reject Pop up
  const handleReject = (rowData: any) => {
    setLoading(true);
    try {
      let advanceSearchViewModel: any[] = [];
      if (gridRef.current) {
        let selectedRows = gridRef.current.api.getSelectedRows();
        if (Array.isArray(selectedRows) && selectedRows.length > 0) {
          selectedRows.forEach((element: any) => {
            const objRejectFile: any = {
              CheckBoxDocumentId: element.DocumentID,
              CheckBoxDocumentStreamId: element.DocumentStreamID,
              AccepectId: element.childAcceptedId,
              DocumentStatus: element.DocumentStatus,
              AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              Remarks: "",
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              QueueType: QueueType,
            };
            advanceSearchViewModel.push(objRejectFile);
          });
        } else {
          const objRejectFile: any = {
            CheckBoxDocumentId: rowData.DocumentID,
            CheckBoxDocumentStreamId: rowData.DocumentStreamID,
            AccepectId: rowData.childAcceptedId,
            DocumentStatus: rowData.DocumentStatus,
            AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
            UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
            Remarks: "",
            ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            QueueType: QueueType,
          };
          advanceSearchViewModel.push(objRejectFile);
        }
      } else {
        const objRejectFile: any = {
          CheckBoxDocumentId: rowData.DocumentID,
          CheckBoxDocumentStreamId: rowData.DocumentStreamID,
          AccepectId: rowData.childAcceptedId,
          DocumentStatus: rowData.DocumentStatus,
          AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
          UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
          Remarks: "",
          ContextName: LocalStorageUtil.getItem("contextName") ?? "",
          QueueType: QueueType,
        };
        advanceSearchViewModel.push(objRejectFile);
      }

      if (advanceSearchViewModel.length > 0) {
        setRejectPopupOpen(true);
        setRejectData(advanceSearchViewModel);
      }
    } catch (error) {
      console.log("Error in handleReject", error);
    } finally {
      setLoading(false);
    }
  };

  //Close Reject Pop up
  const closeRejectPopup = (isCancelClick: boolean, tabValue?: number) => {
    setRejectPopupOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Close Move to Preflight Pop up
  const closeMoveToPreflight = (isCancelClick: boolean) => {
    setMoveToPreflightOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const moveToFinalFolder = async (
    rowData: any,
    value: number,
    status: number
  ) => {
    try {
      let PreworkDetails: any[] = [];
      setContextMenuType(status);
      if (status === 1) {
        // To Final Folder
        setMoveToFinalPopupTitle("Move to Final");
      } else if (status === 2) {
        // Trigger proof WF
        setMoveToFinalPopupTitle("Trigger Proof Workflow");
      } else if (status === 3) {
        // Trigger proof WF
        setMoveToFinalPopupTitle("Trigger Prod Workflow");
      }
      if (value === 0) {
        //Parent
        if (gridRef.current) {
          let selectedRows = gridRef.current.api.getSelectedRows();
          if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
              const objMoveToFinalFolder: any = {
                ParentDocumentID: element.DocumentID,
                DocumentStreamId: element.DocumentStreamID,
                AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
                UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                FinalDocumentId: element.FinalDocID,
                childFileName: element.DownloadFileName,
                ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                individualFilename: element.DownloadFileName,
                toPreflightZipName: element.ToPreflightZipName,
              };
              PreworkDetails.push(objMoveToFinalFolder);
            });
          } else {
            const objMoveToFinalFolder: any = {
              ParentDocumentID: rowData.DocumentID,
              DocumentStreamId: rowData.DocumentStreamID,
              AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              FinalDocumentId: rowData.FinalDocID,
              childFileName: rowData.DownloadFileName,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              individualFilename: rowData.DownloadFileName,
              toPreflightZipName: rowData.ToPreflightZipName,
            };
            PreworkDetails.push(objMoveToFinalFolder);
          }
          if (PreworkDetails.length > 0) {
            setMoveToFinalFolderOpen(true);
            setMoveToFinalFolderData(PreworkDetails);
          }
        }
      }
    } catch (error) {
      console.error("Error in moveToFinalFolder", error);
    }
  };

  // Close Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const closeMoveToFinalFolder = (isCancelClick: boolean) => {
    setMoveToFinalFolderOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Close Reprocess Send to Preflight Pop up
  const closeReprocessSendToPreflight = (isCancelClick: boolean) => {
    setReprocessSendToPreflightOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Move to Preflight Pop up
  const moveToPreflight = (rowData: any, value: number) => {
    try {
      let objMoveToPreflight: any = {
        PreworkDetails: [],
        InstructionId: undefined,
        ToPreflighJobNo: undefined,
        ReprocessDocumentStatus: undefined,
        IsCheckClient: undefined,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      };
      if (value === 0) {
        if (gridRef.current) {
          let selectedRows = gridRef.current.api.getSelectedRows();
          let PreworkDetails: any[] = [];
          if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
              if (element.DocumentStatus !== 20) {
                const preworkDetail: any = {
                  ParentDocumentID: element.DocumentID,
                  ParentDocumentStreamID: element.DocumentStreamID,
                  ChildFileName: element.DownloadFileName,
                  AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
                  FromPreflightJobNumber: element.FromPreflightJobNumber,
                  FinalDocumentId: element.FinalDocID,
                  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                  ToPreflightJobNumber: element.ToPreflightJobNumber,
                  UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                  individualFilename: element.DownloadFileName,
                  toPreflightZipName: element.ToPreflightZipName,
                };
                PreworkDetails.push(preworkDetail);
                objMoveToPreflight = {
                  PreworkDetails: PreworkDetails,
                  InstructionId: undefined,
                  ToPreflighJobNo: element.ToPreflightJobNumber,
                  ReprocessDocumentStatus: element.DocumentStatus,
                  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                };
              } else if (rowData.parentDocumentStatus === 6) {
                selectedRows.forEach((element: any) => {
                  const preworkDetail: any = {
                    ParentDocumentID: element.DocumentID,
                    ParentDocumentStreamID: element.DocumentStreamID,
                    ChildFileName: element.DownloadFileName,
                    AccountId:
                      Number(LocalStorageUtil.getItem("accountId")) || 0,
                    FromPreflightJobNumber: element.FromPreflightJobNumber,
                    FinalDocumentId: element.FinalDocID,
                    ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                    ToPreflightJobNumber: element.ToPreflightJobNumber,
                    UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                    individualFilename: element.DownloadFileName,
                    toPreflightZipName: element.ToPreflightZipName,
                  };
                  PreworkDetails.push(preworkDetail);
                  objMoveToPreflight = {
                    PreworkDetails: PreworkDetails,
                    InstructionId: undefined,
                    ToPreflighJobNo: element.ToPreflightJobNumber,
                    ReprocessDocumentStatus: element.DocumentStatus,
                    ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                  };
                });
              }
            });
            setMoveToPreflightOpen(true);
            setMoveToPreflightData(objMoveToPreflight);
          } else {
            const preworkDetail: any = {
              ParentDocumentID: rowData.DocumentID,
              ParentDocumentStreamID: rowData.DocumentStreamID,
              ChildFileName: rowData.DownloadFileName,
              AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              FromPreflightJobNumber: rowData.FromPreflightJobNumber,
              FinalDocumentId: rowData.FinalDocID,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              ToPreflightJobNumber: rowData.ToPreflightJobNumber,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              individualFilename: rowData.DownloadFileName,
              toPreflightZipName: rowData.ToPreflightZipName,
            };
            PreworkDetails.push(preworkDetail);
            objMoveToPreflight = {
              PreworkDetails: PreworkDetails,
              InstructionId: undefined,
              ToPreflighJobNo: rowData.ToPreflightJobNumber,
              ReprocessDocumentStatus: rowData.DocumentStatus,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            };
            setMoveToPreflightOpen(true);
            setMoveToPreflightData(objMoveToPreflight);
          }
        }
      }
    } catch (error) {
      console.error("Error in moveToPreflight", error);
    }
  };

  return (
    <div>
      <NavigationBar
        menuTitle="Search"
        screenTitle=""
        title="Simple Search"
        text="Simple Search"
      />
      <Row style={{ margin: "1em" }}>
        <Col>
          <Box>
            <div>
              <div>
                <div style={{ marginTop: "10px" }}>
                  <Box
                    component="form"
                    sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "2px",
                        marginTop: "1em",
                        width: "100%",
                      }}
                    >
                      <div
                        className="col-sm-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #a09d9d",
                            borderRadius: "4px",
                            overflow: "hidden",
                            width: "100%",
                            height: "2.47em",
                            fontSize: "11px",
                          }}
                        >
                          <input
                            type="text"
                            placeholder="Search"
                            value={txtSearch}
                            onChange={handleSearchChange}
                            onKeyDown={handleSearchKeyPress}
                            className="searchInput"
                            style={{
                              width: "100%",
                              height: "2.47em",
                              padding: "0.5em",
                            }}
                          />
                          <Tooltip title="Please click to search">
                            <button
                              onClick={handleSearchSubmit}
                              className="searchButton"
                            >
                              <SearchIcon style={{ color: "#006ab6" }} />
                            </button>
                          </Tooltip>
                        </div>

                        {resetShow && (
                          <Tooltip title="Please click to Reset">
                            <ClearIcon
                              style={{
                                height: "1em",
                                width: "1em",
                                color: "var(--text-color)",
                              }}
                              onClick={handleReset}
                            />
                          </Tooltip>
                        )}
                      </div>
                      <div
                        className="col-sm-4"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {
                          <>
                            {isPagePermission(
                              "AllowDownstream",
                              "Search",
                              1413
                            ) &&
                              LocalStorageUtil.getItem("contextName") ===
                                "DocDistro_BrightHouseFinancials" && (
                                <Form.Check
                                  id="downstream"
                                  type="radio"
                                  label="Downstream"
                                  radioGroup="queueType"
                                  style={{
                                    marginRight: "10px",
                                    color: "var(--text-color)",
                                  }}
                                  checked={QueueType === 2}
                                  onChange={handleQueueTypeChange}
                                  value="2"
                                />
                              )}
                            {isPagePermission("AllowPrework", "Search", 1414) &&
                              LocalStorageUtil.getItem("contextName") ===
                                "DocDistro_BrightHouseFinancials" && (
                                <Form.Check
                                  id="prework"
                                  type="radio"
                                  label="Prework"
                                  radioGroup="queueType"
                                  style={{
                                    marginRight: "10px",
                                    color: "var(--text-color)",
                                  }}
                                  checked={QueueType === 1}
                                  onChange={handleQueueTypeChange}
                                  value="1"
                                />
                              )}
                          </>
                        }
                      </div>
                      {ShowRecords && (
                        <div
                          className="col-sm-4"
                          style={{
                            marginTop: "-1em",
                            display: "flex",
                            justifyContent: "right",
                            width: "42%",
                          }}
                        >
                          {deleteRightShow &&
                            isPagePermission("Allow Delete", "Search", 804) && (
                              <Button
                                variant="contained"
                                id="delete"
                                size="small"
                                onClick={deleteSelectetdDocuments}
                                className="button"
                              >
                                Delete
                              </Button>
                            )}

                          {zipDownload && (
                            <Button
                              id="zipanddownload"
                              variant="contained"
                              size="small"
                              onClick={downloadSelectedFiles}
                              className="button download-zip-button"
                            >
                              Zip and Download
                            </Button>
                          )}
                        </div>
                      )}
                    </div>
                  </Box>
                  {resetErrorMsg && (
                    <Typography
                      color="error"
                      variant="body2"
                      style={{ marginBottom: "10px" }}
                    >
                      Please enter the text to search
                    </Typography>
                  )}
                </div>
              </div>

              {ShowRecords && (
                <div>
                  <div
                    className="ag-theme-quartz-dark"
                    style={{ height: "70vh", width: "100%", marginTop: "1em" }}
                  >
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={rowData}
                      onGridReady={onGridReady}
                      ref={gridRef}
                      pagination={true}
                      paginationPageSize={defaulPageSize}
                      paginationPageSizeSelector={pageSizeSelector}
                      gridOptions={{
                        rowSelection: {
                          mode: "multiRow",
                          checkboxes: true,
                          headerCheckbox: true,
                          enableClickSelection: false,
                        },
                      }}
                      headerHeight={30}
                      rowHeight={20}
                      domLayout="normal"
                      rowGroupPanelShow="always"
                      pivotPanelShow="always"
                      overlayNoRowsTemplate={
                        '<span class="ag-overlay-loading-center">No rows to show</span>'
                      }
                      loading={!rowData || showLoader}
                      loadingOverlayComponent={CustomLoadingOverlay}
                      context={{ QueueType }}
                    />
                  </div>
                </div>
              )}

              <ConfirmationDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                onConfirm={dialogProps.onConfirm}
                contentText={dialogProps.contentText}
                closeText={dialogProps.closeText}
                confirmText={dialogProps.confirmText}
                dialogTitle={dialogProps.dialogTitle}
              />

              <div>
                <InfoDrawer
                  isOpen={drawerOpen}
                  onClose={toggleDrawer(false)}
                  title="Document Info"
                  tabLabels={["Information", "Version History"]}
                  selectedDocument={selectedDocument}
                />
              </div>
              {assetHistoryOpen && (
                <AssetHistory
                  isOpen={assetHistoryOpen}
                  onClose={closeAssetHistory}
                  title=""
                  selectedData={assetHistoryData}
                />
              )}
              {/* Delete Confirmation dialogbox */}
              {deleteConfirmationDialogOpen && (
                <ConfirmationAlert
                  isOpen={deleteConfirmationDialogOpen}
                  onClose={(e) => closeConfirmationDialogbox(e)}
                  title="Delete Confirmation"
                  selectedData={deleteDocumentData}
                  isArf={isArfMessage}
                  screen="DownstreamSummary"
                />
              )}
              {/* Reprocess SubSystem dialogbox */}
              {reprocessSubSystemOpen && (
                <DownstreamSubSystemReprocessPopup
                  isOpen={reprocessSubSystemOpen}
                  onClose={closeReprocessSubSystemDialogbox}
                  title="Reprocess"
                  selectedData={reprocessSubSystemOpenData}
                  documentStatusFlag={false}
                />
              )}
              {/* Upload Files Dialog */}
              {uploadFilesOpen && (
                <FileUploads
                  isOpen={uploadFilesOpen}
                  onClose={closeUploadFiles}
                  title="Upload Files"
                  selectedData={uploadFilesData}
                  screenType="advanceSearch"
                />
              )}

              {/* Add Notes Dialog */}
              {addNotesOpen && (
                <AddNotes
                  isOpen={addNotesOpen}
                  onClose={closeAddNotes}
                  title="Add Notes"
                  selectedData={addNotesData}
                  screenType="PreworkDetails"
                />
              )}

              {/* Rename popup */}
              {renamePopupOpen && (
                <RenamePopup
                  isOpen={renamePopupOpen}
                  onClose={closeRenamePopup}
                  title="Rename File"
                  selectedData={renameData}
                />
              )}

              {/* Reject popup */}
              {rejectPopupOpen && (
                <RejectFile
                  isOpen={rejectPopupOpen}
                  onClose={closeRejectPopup}
                  title="Reject File"
                  selectedData={rejectData}
                />
              )}
              {/* Move to Preflight Dialog */}
              {moveToPreflightOpen && (
                <MoveToPreflightPopup
                  isOpen={moveToPreflightOpen}
                  onClose={closeMoveToPreflight}
                  title="Move To Preflight"
                  selectedData={moveToPreflightData}
                  documentStatus={documentStatusValue}
                />
              )}

              {/* Move to Final Folder Dialog */}
              {moveToFinalFolderOpen && (
                <MoveToFinal
                  isOpen={moveToFinalFolderOpen}
                  onClose={closeMoveToFinalFolder}
                  title={moveToFinalPopupTitle}
                  selectedData={moveToFinalFolderData}
                  contextMenuType={contextMenuType}
                />
              )}

              {/* Reprocess Send to Preflight Dialog */}
              {reprocessSendToPreflightOpen && (
                <ReprocessSendToPreflight
                  isOpen={reprocessSendToPreflightOpen}
                  onClose={closeReprocessSendToPreflight}
                  title="Reprocess"
                  selectedData={reprocessSendToPreflightData}
                />
              )}
            </div>
          </Box>
        </Col>
      </Row>
    </div>
  );
};

export default SimpleSearch;
